<template>
    <div>
        <header class="navContent">
            <div class="nav">
                <div class="menu" v-if="!isLogin">
                    <button type="button" class="brand" aria-label="返回上考首页" @click="goHome">
                        <span class="logo" aria-hidden="true"></span>
                        <span class="brandName">上考<small>SHANGKAO</small></span>
                    </button>
                    <div class="changeIdentity">
                        <change-identity ref="changeIdentity" @update="update"></change-identity>
                        <button type="button" class="identityName" @click="openIdentity()" :disabled="switchingIdentity || !identityIds.length" :aria-busy="switchingIdentity" :title="identityName"><i class="el-icon-collection" aria-hidden="true"></i><span>{{switchingIdentity ? '正在切换科目…' : (identityName || '选择科目')}}</span><i class="el-icon-arrow-down" aria-hidden="true"></i></button>
                    </div>
                    <nav class="menus" aria-label="主导航">
                        <!-- 题库、论坛为固定入口；其余菜单由当前学科接口决定 -->
                        <button type="button" class="menuItem" :class="activeName=='/home' || activeName.indexOf('/study/') === 0 ? 'active':''" @click="handleSelect('/home')">首页</button>
                        <button type="button" class="menuItem" :class="activeName=='/questions' ? 'active':''" @click="handleSelect('/questions')">题库</button>
                        <button type="button" class="menuItem" :class="activeName=='/forum' ? 'active':''" @click="handleSelect('/forum')">论坛</button>
                        <button type="button"
                            class="menuItem"
                            v-for="(item, index) in navMenus"
                            :key="(item.category || 'nav') + '-' + index"
                            :class="item.path && (activeName == item.path || (item.path === '/medicalCode' && activeName.indexOf('/medicalCode/') === 0)) ? 'active' : ''"
                            @click="handleSelect(item.path)"
                        >{{ item.title }}</button>
                        <!-- 接口无会员中心，写死入口 -->
                        <button type="button" class="menuItem" :class="activeName=='/openMember' ? 'active':''" @click="handleSelect('/openMember')">会员中心</button>
                    </nav>
                </div>
                <div class="logon" v-if="!isLogin">
                    <button type="button" class="aiAsk" title="AI 助手" aria-label="打开 AI 助手" @click="aiAsk"><img src="../assets/aiImg.png" alt=""><span>AI 助手</span></button>
                    <div v-if="userInfo['user_id']" class="userActions">
                        <el-dropdown trigger="click">
                            <div class="avatar-wrapper">
                                <img :src="eEUtils.imgUrl+userInfo['avatar']" class="user-avatar" alt="个人头像">
                                <span>{{userInfo['nickname']}}</span>
                                <i class="el-icon-arrow-down" />
                            </div>
                            <el-dropdown-menu slot="dropdown" class="web-nav-dropdown">
                                <el-dropdown-item @click.native="personInfo">
                                    <div class="userInfo">
                                        <img class="userInfoImg" :src="eEUtils.imgUrl+userInfo['avatar']">
                                        <div class="userInfoName">
                                            <div class="userNickName"><span>{{userInfo['nickname']}}</span><img src="../assets/member.png" v-if="userInfo['vip_day']>0"/> </div>
                                            <span class="userSchool" v-if="userInfo['utype']==1">{{userInfo['hospital']}}|{{userInfo['department']}}</span>
                                            <span class="userSchool" v-if="userInfo['utype']==2">{{userInfo['school']}}|{{userInfo['major']}}</span>
                                        </div>
                                    </div>
                                </el-dropdown-item>
                                <el-dropdown-item  divided @click.native="goHome">首页</el-dropdown-item>
                                <el-dropdown-item  @click.native="personInfo">个人中心</el-dropdown-item>
<!--                                <el-dropdown-item  @click.native="points">积分福利</el-dropdown-item>-->
<!--                                <el-dropdown-item  @click.native="partTimeJob">兼职教研</el-dropdown-item>-->
                                <el-dropdown-item  @click.native="openMember">会员中心</el-dropdown-item>
                                <el-dropdown-item divided @click.native="unlogin">退出登录</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <button type="button" class="notice" v-if="userInfo['user_id']" aria-label="通知消息" title="通知消息" @click="goRouter('/notice')">
                            <el-badge :is-dot="notice ? true : false" class="item">
                                <i class="el-icon-bell"></i>
                            </el-badge>
                        </button>
                    </div>
                    <button type="button" class="loginButton" v-else @click="goLogin()">登录 / 注册</button>
                </div>
            </div>
        </header>
    </div>
</template>

<script>
import {getIdentityByEndTime, getNotLabelTree, getQuestionNavigation, logout, myMessageRed, setSwitchIdentity} from "@/plugins/api";
import changeIdentity from "@/components/changeIdentity";
import {EventBus} from "@/plugins/EUtils";
import {mapGetters} from "vuex";
import {isLastIdentity, normalizeIdentityTree} from '@/plugins/identityTree.mjs';

export default {
    components:{changeIdentity},
    props:{
        isLogin: {
            type: Boolean,
            default: false
        },
    },
    data(){
        return{
            eEUtils:EUtils,
            timer:null,
            activeName:'/questions',
            identityIds:[],
            identityId:[],
            identity_id:'',
            notice:0,
            navMenus:[], // 接口导航（会员中心写死，不在此列表）
            navMenusRequestId:0,
            switchingIdentity:false,
        }
    },
    watch:{
        '$route.path'(path) { this.activeName = path },
    },
    computed: {
        ...mapGetters([
            'userInfo',
            'identityName'
        ])
    },
    methods:{
        handleSelect(key, keyPath){
            if(!key || key==this.activeName) return
            this.activeName = key
            this.goRouter(key)
        },
        // human / autonomous 从 getIdentityByEndTime 抽出；其余导航分类跳转
        resolveNavPath(category){
            const map = {
                human: '/humanDialogue',
                autonomous: '/autonomous',
                daily: '/dailyPractice',
                points: '/points',
                partTime: '/partTimeJob',
                partTimeJob: '/partTimeJob',
                medicalCode: '/medicalCode',
                'medical-code': '/medicalCode',
            }
            return map[category] || ''
        },
        getNavMenus(){
            if (this.isLogin) return
            this.navMenus = []
            const requestId = ++this.navMenusRequestId
            if (this._navMenusTimer) clearTimeout(this._navMenusTimer)
            if (!this.identity_id) return
            this._navMenusTimer = setTimeout(() => {
                this.fetchNavMenus(requestId)
            }, 80)
        },
        fetchNavMenus(requestId){
            if (this.isLogin) return
            if (!this.identity_id) {
                this.navMenus = []
                return
            }
            const reqId = this.identity_id
            const params = { identity_id: reqId }
            Promise.all([
                getIdentityByEndTime(params).catch(() => null),
                getQuestionNavigation(params).catch(() => null),
            ]).then(([identityRes, navRes]) => {
                if (requestId !== this.navMenusRequestId || reqId !== this.identity_id) return
                const menus = []

                // 1) 从末级身份里抽出 human、autonomous（有则展示，title 用接口）
                const identityList = (identityRes && identityRes.data) ? EUtils.deepClone(identityRes.data) : []
                const pinOrder = ['human', 'autonomous']
                pinOrder.forEach(category => {
                    const found = identityList.find(item => item && item.category === category)
                    if (!found) return
                    menus.push({
                        category,
                        title: found.title,
                        path: this.resolveNavPath(category)
                    })
                })

                // 2) navigation 接口菜单
                const list = (navRes && navRes.data) ? EUtils.deepClone(navRes.data) : []
                let squareMerged = false
                list.forEach(item => {
                    if (!item || !item.category) return
                    const category = item.category
                    // 指定隐藏
                    if (category === 'team' || category === 'WxProgram' || category === 'img') return
                    // 题库、论坛是固定入口；human/autonomous 已从身份接口抽出
                    if (category === 'question' || category === 'forum') return
                    if (category === 'human' || category === 'autonomous') return
                    // unit、exam 合成一个「题集」
                    if (category === 'unit' || category === 'exam') {
                        if (squareMerged) return
                        squareMerged = true
                        menus.push({ category: 'unit', title: '题集', path: '/square' })
                        return
                    }
                    // 其余全部漏出
                    menus.push({
                        category,
                        title: item.title,
                        path: this.resolveNavPath(category)
                    })
                })
                this.navMenus = menus
            })
        },
        findIdentity(path){
            if (!Array.isArray(path) || !path.length) return null
            let level = this.identityIds
            let node = null
            const actualPath = []
            for (const id of path) {
                node = (level || []).find(item => String(item.identity_id) === String(id))
                if (!node) return null
                actualPath.push(node.identity_id)
                level = node.children || []
            }
            if (!isLastIdentity(node) || !node.title) return null
            return { path: actualPath, id: node.identity_id, name: node.title }
        },
        firstIdentity(nodes = this.identityIds, path = []){
            for (const node of nodes || []) {
                const nextPath = path.concat(node.identity_id)
                if (!isLastIdentity(node)) {
                    const child = this.firstIdentity(node.children || [], nextPath)
                    if (child) return child
                } else if (node.title) {
                    return { path: nextPath, id: node.identity_id, name: node.title }
                }
            }
            return null
        },
        commitIdentity(selection){
            const previousId = this.$store.getters.identityId
            this.identityId = selection.path.slice()
            this.identity_id = selection.id
            EUtils.setIdentityPath(this.identityId, 60*60*60*24*30*30)
            this.$store.dispatch('app/setIdentityId', selection.id)
            this.$store.dispatch('app/setIdentityName', selection.name)
            this.getNavMenus()
            if (String(previousId || '') !== String(selection.id)) EventBus.$emit('identity_id', selection.id)
        },
        restoreIdentity(selection){
            const previousId = this.$store.getters.identityId
            this.commitIdentity(selection)
            if (String(previousId || '') !== String(selection.id) || !this.userInfo.user_id) {
                this.getInfo(selection.id).catch(() => {})
            }
        },
        async applyIdentity(selection, goHome = false){
            if (!selection || this.switchingIdentity) return false
            if (String(this.identity_id) === String(selection.id)) {
                if (goHome && this.$route.path !== '/home') await this.$router.replace('/home').catch(() => {})
                return true
            }
            this.switchingIdentity = true
            try {
                await setSwitchIdentity({ identity_id: selection.id })
                this.commitIdentity(selection)
                await this.getInfo(selection.id).catch(() => {})
                if (goHome && this.$route.path !== '/home' && EUtils.getCookie('Authorization')) {
                    this.activeName = '/home'
                    await this.$router.replace('/home').catch(() => {})
                }
                return true
            } catch (_) {
                if (goHome && this.$refs.changeIdentity && EUtils.getCookie('Authorization')) {
                    this.$refs.changeIdentity.open(this.identityId, this.identityIds)
                }
                return false
            } finally {
                this.switchingIdentity = false
            }
        },
        update(path){
            const selection = this.findIdentity(path)
            if (selection) this.applyIdentity(selection, true)
        },
        aiAsk(){
            this.handleSelect('/ai/general')
        },
        goHome(){
            this.handleSelect('/home')
        },
        openMember(){
            this.handleSelect('/openMember')
        },
        points(){
            this.handleSelect('/points')
        },
        partTimeJob(){
            this.handleSelect('/partTimeJob')
        },
        personInfo(){
            this.$router.replace('/personalCenter')
        },
        unlogin(){
            logout().then((res)=>{
                EUtils.delCookie('Authorization')
                window.location.replace(`${process.env.BASE_URL.replace(/\/+$/, '')}/login`)
            })
        },
        goLogin(){
            EUtils.delCookie('Authorization')
            window.location.replace(`${process.env.BASE_URL.replace(/\/+$/, '')}/login`)
        },
        openIdentity(){
            if (!this.switchingIdentity && this.identityIds.length) {
                this.$refs.changeIdentity.open(this.identityId,this.identityIds)
            }
        },
        getIdentity(){
            if(!this.isLogin){
                getNotLabelTree().then(res=>{
                    if(res.code == '200'){
                        this.identityIds = normalizeIdentityTree(res.data)
                        const cachedPath = EUtils.getIdentityPath()
                        // Derive the title from the current tree, never from a stale name cookie.
                        const cachedSelection = this.findIdentity(cachedPath)
                        if (cachedSelection) this.restoreIdentity(cachedSelection)
                        else {
                            const firstSelection = this.firstIdentity()
                            if (firstSelection) this.applyIdentity(firstSelection)
                        }
                    }
                }).catch(() => {})
            }
        },
        getInfo(identity_id){
            return this.$store.dispatch('app/setUserInfo', identity_id)
        },
        onStart(){
            this.getIdentity()
        },
        goRouter(path){
            this.$router.push(path)
        },
        getMessageCount(){
            if(!this.isLogin) {
                myMessageRed().then(res => {
                    this.notice = res.data.red;
                })
            }
        }
    },
    mounted() {
        let activeName = window.location.pathname
        this.activeName = activeName.replace('/web','')
        this.onStart();
        this.getMessageCount();
        this.$store.dispatch('app/getOssToken')
    },
    beforeDestroy() {
        if (this._navMenusTimer) clearTimeout(this._navMenusTimer)
        this.navMenusRequestId += 1
    },
}
</script>

<style scoped lang="scss">
.navContent {
    position: relative;
    z-index: 30;
    width: 100%;
    background: rgba(255, 255, 255, .98);
    border-bottom: 1px solid #e7eaf0;
    box-shadow: 0 3px 18px rgba(32, 48, 67, .035);
    color: #27364a;

    .nav {
        display: grid;
        grid-template-columns: auto minmax(0, 1fr) auto;
        grid-template-areas: "brand identity account" "menus menus menus";
        align-items: center;
        column-gap: 22px;
        width: min(100%, 1280px);
        margin: 0 auto;
        padding: 0 28px;
        box-sizing: border-box;
    }
    .menu { display: contents; }
    button { font-family: inherit; }
    .brand {
        grid-area: brand;
        display: inline-flex;
        align-items: center;
        gap: 10px;
        min-height: 70px;
        padding: 0;
        border: 0;
        background: transparent;
        color: #26374c;
        cursor: pointer;
        text-align: left;
        white-space: nowrap;
    }
    .logo {
        display: block;
        flex: none;
        width: 42px;
        height: 42px;
        border-radius: 50%;
        background: url("../assets/logo.png") no-repeat center / contain;
    }
    .brandName {
        display: flex;
        flex-direction: column;
        font-size: 21px;
        font-weight: 800;
        line-height: 1.05;
        letter-spacing: .03em;
        small { margin-top: 5px; color: #a97551; font-size: 9px; font-weight: 700; letter-spacing: .19em; }
    }
    .changeIdentity {
        grid-area: identity;
        display: flex;
        align-items: center;
        min-width: 0;
        .identityName {
            display: inline-flex;
            align-items: center;
            gap: 9px;
            width: max-content;
            max-width: 100%;
            min-height: 40px;
            padding: 8px 14px;
            border: 1px solid #e9e0da;
            border-radius: 10px;
            background: #fbf7f3;
            color: #415066;
            font-size: 13px;
            font-weight: 600;
            line-height: 1.4;
            text-align: left;
            cursor: pointer;
            transition: border-color .16s, background .16s, box-shadow .16s;
            span { min-width: 0; overflow-wrap: anywhere; }
            i:first-child { flex: none; color: #bd7144; font-size: 16px; }
            i:last-child { flex: none; color: #a97454; font-size: 11px; }
            &:hover, &:focus-visible { border-color: #cfaa8e; background: #fff9f4; box-shadow: 0 0 0 3px rgba(189, 113, 68, .08); outline: 0; }
        }
    }
    .menus {
        grid-area: menus;
        display: flex;
        align-items: center;
        gap: 4px;
        min-width: 0;
        overflow-x: auto;
        padding: 7px 0 9px;
        border-top: 1px solid #f0f1f3;
        scrollbar-width: none;
        scroll-snap-type: x proximity;
        &::-webkit-scrollbar { display: none; }
        .menuItem {
            flex: none;
            min-height: 35px;
            padding: 7px 14px;
            border: 0;
            border-radius: 9px;
            background: transparent;
            color: #536174;
            font-size: 14px;
            font-weight: 500;
            white-space: nowrap;
            cursor: pointer;
            scroll-snap-align: start;
            transition: background .16s, color .16s;
            &:hover, &:focus-visible { background: #f8f1eb; color: #a65e35; outline: 0; }
            &.active { background: #f8eee7; color: #a85f36; font-weight: 700; }
        }
    }
    .logon {
        grid-area: account;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 12px;
        min-width: 0;
    }
    .aiAsk, .notice {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex: none;
        height: 38px;
        border: 1px solid transparent;
        border-radius: 10px;
        background: transparent;
        color: #667486;
        cursor: pointer;
        &:hover, &:focus-visible { background: #f8f1eb; color: #a65e35; outline: 0; }
    }
    .aiAsk {
        gap: 6px;
        padding: 0 8px 0 4px;
        color: #8c613f;
        font-size: 12px;
        font-weight: 600;
        img { width: 28px; height: 28px; object-fit: contain; }
    }
    .userActions { display: flex; align-items: center; gap: 6px; min-width: 0; }
    .avatar-wrapper {
        display: flex;
        align-items: center;
        gap: 8px;
        max-width: 190px;
        padding: 4px 5px 4px 4px;
        border-radius: 11px;
        color: #415066;
        font-size: 13px;
        font-weight: 600;
        cursor: pointer;
        transition: background .16s;
        &:hover { background: #f7f8fa; }
        .user-avatar { flex: none; width: 32px; height: 32px; border-radius: 50%; object-fit: cover; background: #f2eee9; }
        span { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
        i { flex: none; color: #9aa4af; font-size: 10px; }
    }
    .notice { width: 38px; font-size: 17px; }
    .loginButton {
        flex: none;
        min-height: 36px;
        padding: 0 16px;
        border: 1px solid #bd7144;
        border-radius: 9px;
        background: #bd7144;
        color: #fff;
        font-size: 13px;
        font-weight: 600;
        cursor: pointer;
        &:hover, &:focus-visible { background: #aa6037; border-color: #aa6037; outline: 0; }
    }
}
@media (max-width: 700px) {
    .navContent .nav { column-gap: 8px; padding: 0 14px; }
    .navContent .brand { min-height: 66px; }
    .navContent .brandName { display: none; }
    .navContent .logo { width: 40px; height: 40px; }
    .navContent .changeIdentity .identityName { min-height: 38px; padding: 7px 9px; font-size: 12px; gap: 6px; }
    .navContent .logon { gap: 3px; }
    .navContent .aiAsk { width: 34px; padding: 0; span { display: none; } img { width: 27px; height: 27px; } }
    .navContent .avatar-wrapper { width: 36px; height: 38px; padding: 3px; box-sizing: border-box; span, i { display: none; } .user-avatar { width: 30px; height: 30px; } }
    .navContent .notice { width: 32px; }
    .navContent .menus { margin: 0 -14px; padding: 7px 14px 9px; }
    .navContent .menus .menuItem { padding: 7px 12px; font-size: 13px; }
}
@media (max-width: 390px) {
    .navContent .nav { padding: 0 10px; column-gap: 5px; }
    .navContent .menus { margin: 0 -10px; padding-left: 10px; padding-right: 10px; }
    .navContent .changeIdentity .identityName i:first-child { display: none; }
}
@media (prefers-color-scheme: dark) {
    .navContent {
        background: #20242c;
        border-bottom-color: #3a414d;
        box-shadow: none;
        .brand { color: #f1f3f6; }
        .menus { border-top-color: #3a414d; }
        .menus .menuItem { color: #d5dce5; &:hover, &.active { background: #39342f; color: #f0b689 !important; } }
        .changeIdentity .identityName { background: #2b3039; border-color: #454b54; color: #e4e8ef; &:hover { background: #343a44; } }
        .avatar-wrapper { color: #e4e8ef; &:hover { background: #303741; } }
        .aiAsk, .notice { color: #d5dce5; &:hover { background: #303741; color: #f0b689; } }
    }
}
</style>
<style lang="scss">
.web-nav-dropdown {
    min-width: 240px;
    padding: 8px;
    border: 1px solid #e8ecf0;
    border-radius: 14px;
    box-shadow: 0 15px 38px rgba(29, 44, 62, .14);
    .el-dropdown-menu__item { border-radius: 8px; color: #536174; font-size: 13px; &:hover { background: #f8eee7; color: #a85f36; } }
    .el-dropdown-menu__item--divided { border-top-color: #edf0f2; }
    .userInfo { display: flex; align-items: center; gap: 11px; padding: 8px 2px; .userInfoImg { width: 40px; height: 40px; border-radius: 50%; object-fit: cover; } .userInfoName { min-width: 0; line-height: 1.45; } .userNickName { display: flex; align-items: center; gap: 5px; color: #26364a; font-weight: 700; img { width: 14px; height: 14px; } } .userSchool { display: block; max-width: 166px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; color: #8b96a2; font-size: 11px; } }
}
</style>
